import ChatIcon from "@mui/icons-material/Chat"
import NotificationsIcon from "@mui/icons-material/Notifications"
import { IconButton } from "@mui/material"
import React, { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import ProfileMenu from "./ProfileMenu"
import TabsMenu from "./TabsMenu"
import { PROFILE } from "../../utils/constants"

function Header() {
  const [anchorEl, setAnchorEl] = useState(null)
  const [isMobile, setIsMobile] = useState(window.innerWidth < 600)

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 600)
    }
    window.addEventListener("resize", handleResize)
    return () => window.removeEventListener("resize", handleResize)
  }, [])

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget)
  }

  const handleMenuClose = () => {
    setAnchorEl(null)
  }

  return (
    <div
      className="row-between"
      style={{
        borderBottom: "2px solid #dfdfdd",
        padding: "0px 40px",
        display: "flex",
        alignItems: "center",
      }}
    >
      <img
        src="https://ayrshireeyeclinic.com/wp-content/uploads/2022/12/ayrshire-eye-clinic-400-300x77.png"
        style={{ height: "60px", cursor: "pointer" }}
        alt="Logo"
      />

      <div
        style={{
          display: "flex",
          columnGap: "20px",
          alignItems: "center",
        }}
      >
        {!isMobile && <TabsMenu isMobile={isMobile} />}
        {/* 
                <IconButton className="icon-styles">
                    <ChatIcon />
                </IconButton>
                */}
        <IconButton className="icon-styles">
          <NotificationsIcon />
        </IconButton>

        <img
          src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQeJHWZvcQqXqBta04Ok3OjxguHy_hHXefxmI-uHBCjJIfx3pz2hUsFqkFSFBJgrHgE0og&usqp=CAU"
          className="profile-image-mini"
          onClick={handleClick}
          alt={PROFILE}
        />
      </div>

      <ProfileMenu
        anchorEl={anchorEl}
        handleMenuClose={handleMenuClose}
        isMobile={isMobile}
      />
    </div>
  )
}

export default Header
